import React, { useState, useEffect, useRef } from "react";
import LogoForModal from "../../LogoForModal";
import Button from "../../styled/Button/Button";
import { ButtonContainer, StakeLocked } from "../Locked/style";
import InputAmount from "../../InputAmount/InputAmount";
// import BigNumber from "big-number";
import BigNumber from "bignumber.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Claim,
  getFirstLoadData,
  getSecondLoadData,
  calculateVesting,
} from "../../../common/BPADBlockStakeContract";
import { useSelector, useDispatch } from "react-redux";
import { setRealTimeValue, setFirstLoadData, setSecondLoadData } from "../../../store/actions/globalActions";

function Locked({ onHide, onLoadStart, onLoadStop }) {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const { currentChainId, networkIdFromURL } = useSelector(
    (state) => state.global
  );
  const { isLogin } = useSelector((state) => state.login);
  const { corePoolContract, corePoolAddress } = useSelector(
    (state) => state.global
  );
  const { poolFactoryAddress } = useSelector(
    (state) => state.global.poolAddresses
  );
  const { poolFactoryContract, rewardContract, poolTokenContract } =
    useSelector((state) => state.global.poolContracts);
  const { poolTokenDecimal } = useSelector(
    (state) => state.global.rewardDecimalPoolTokenDecimal
  );
  const { rewardTknSymbol } = useSelector(
    (state) => state.global.tknSymbol
  );
  const { rewardTokenPerBlock } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );
  const {
    reward,
  } = useSelector(
    (state) => state.global.actionBasedData
  )
  const dispatch = useDispatch();

  const UnStakeAmount = (amount) => {
    setAmount(amount);
  };

  function success(Message) {
    toast(Message);
  }
  const startLoading = () => {
    setLoading(true);
    onLoadStart && onLoadStart();
  };

  const stopLoading = () => {
    setLoading(false);
    onLoadStop && onLoadStop();
  };

  const unStakeEligible = async () => {
    const vesting = await calculateVesting(
      corePoolContract,
      poolFactoryContract
    );
    // console.log("q", vesting?.quotient);
    // console.log("can done vesting");
    // console.log("remaining", vesting?.remainingTime);
    if (currentChainId !== networkIdFromURL) {
      success("Wrong Network");
      return "";
    }

    if (
      vesting?.quotient > 1 &&
      reward >= amount &&
      amount > 0 &&
      currentChainId === networkIdFromURL
    ) {
      startLoading();
      // let totalAmount = new BigNumber(amount * Math.pow(10, poolTokenDecimal));
      let totalAmount = new BigNumber(amount).times(new BigNumber(10).pow(poolTokenDecimal).toString()).toString();
      const Transaction = await Claim(totalAmount, isClaimed, corePoolContract);
      if (Transaction) {
        success(`${amount} reward claimed Successfully`);
      } else {
        success("Transaction Cancelled");
      }
      stopLoading();

      onHide && onHide();
    } else {
      if (vesting?.remainingTime > 0) {
        success(
          `Your vesting period is not complete please wait for  ${vesting?.remainingTime} second`
        );
      } else {
        if (amount <= 0) {
          success("Claim amount must be greater than zero");
        }
        if (reward < amount) {
          success("Claim amount must be smaller than Eligible Claim");
        }
      }
    }
  };

  const fetchAndSetFirstLoadData = async (
    corePoolContract,
    corePoolAddress,
    poolFactoryContract,
    poolTokenContract,
    chainId,
    rewardPerBlock
  ) => {
    let data = await getFirstLoadData(
      corePoolContract,
      corePoolAddress,
      poolFactoryContract,
      poolTokenContract,
      chainId,
      rewardPerBlock
    )
    dispatch(
      setFirstLoadData(
        data.Apy,
        data.balanceOfTvl,
        data.totalStakevalue,
        data.totalStake,
        data.reward,
      )
    )
  }

  const fetchAndSetSecondLoadData = async (
    corePoolContract,
    poolFactoryContract,
    poolFactoryAddress,
    rewardContract,
    poolTokenContract,
  ) => {
    let data = await getSecondLoadData(
      corePoolContract,
      poolFactoryContract,
      poolFactoryAddress,
      rewardContract,
      poolTokenContract
    )
    dispatch(
      setSecondLoadData(
        data.tokenBalance,
        data.EligibleunStake,
        data.RewardDiff,
        data.rewardDistributed,
        data.rewardBalanceOf,
      )
    )
  }

  async function isClaimed(isClaimed) {
    //TODO: gloable update
    if (isClaimed) {
      await Promise.all([
        fetchAndSetFirstLoadData(corePoolContract,
          corePoolAddress,
          poolFactoryContract,
          poolTokenContract,
          networkIdFromURL,
          rewardTokenPerBlock),
        fetchAndSetSecondLoadData(corePoolContract,
          poolFactoryContract,
          poolFactoryAddress,
          rewardContract,
          poolTokenContract)
      ])
    }
  }

  return (
    <StakeLocked>
      <LogoForModal />

      <InputAmount
        amount="Amount"
        balance={
          reward && rewardTknSymbol
            ? `Eligible Claim: ${reward + " " + rewardTknSymbol}`
            : "Eligible Claim: 0"
        }
        onChange={UnStakeAmount}
      />

      <ButtonContainer>
        <Button
          loading={loading}
          disabled={loading}
          loadingContent={"Claiming..."}
          disableHelper="Enter valid amount"
          onClick={() => isLogin && unStakeEligible()}
          color="primary"
          modal
        >
          CLAIM
        </Button>
      </ButtonContainer>
    </StakeLocked>
  );
}

export default Locked;
